import { render, staticRenderFns } from "./Suscription.vue?vue&type=template&id=20fd4768&"
import script from "./Suscription.vue?vue&type=script&lang=js&"
export * from "./Suscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports